export default __webpack_public_path__ + "static/media/C0000.70f4509a.png";